module.exports = __webpack_public_path__ + "media/images/icons/maestro_logo-ff6bfa270a62bd4da789d9e604ddd07f.png";